import './type.scss';

import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import Button, { ButtonType } from 'hellospa/foundation/control/button';
import fonts from './constants/fonts';
import * as signatureTypes from './constants/signature-types';
import { withSignatureModalContext } from './contexts/signature-modal';
import { changeFont, nextFont } from './contexts/signature-modal/actions';

const messages = defineMessages({
  linkText: {
    id: '',
    description: 'Text for a button which changes the font of the typed-in signature when clicked.',
    defaultMessage: 'Change font',
  },
  placeholderS: {
    id: '',
    description: 'Placeholder text for an input field when the user types in their name.',
    defaultMessage: 'Your name',
  },
});

class Type extends React.PureComponent {

  inputRef = React.createRef();

  componentDidMount() {
    const { state, dispatch } = this.props.signatureModalContext;

    // Check if we have loaded any fonts yet. If not, let's
    // load first one
    if (state.currentFontIndex === null) {
      dispatch(changeFont(0));
    }

    this.props.enableInsertButtonCallback(this.shouldEnableInsert());
  }

  onInputChange = () => {
    this.props.enableInsertButtonCallback(this.shouldEnableInsert());
  };

  onChangeFontPressed = () => {
    const { state, dispatch } = this.props.signatureModalContext;

    if (!state.isLoadingFont) {
      dispatch(nextFont());
    }
  };

  getSignatureData() {
    const text = this.inputRef.current.value.trim();

    return {
      create_type_code: signatureTypes.TYPED,
      signature: {
        text,
        font_family: fonts[this.props.signatureModalContext.state.currentFontIndex],
      },
    };
  }

  shouldEnableInsert() {
    if (!this.inputRef.current) return false;

    return !!this.inputRef.current.value.trim().length;
  }

  isChineseLocale() {
    const intl = this.props.intl;
    const locale = intl ? intl.locale : null;
    return locale === 'zh-CN';
  }

  render() {
    const { currentFontIndex, isLoadingFont } = this.props.signatureModalContext.state;

    return (
      <div className="signature-modal-type">
        <div className="signature-modal-type__input-container">
          <input
            ref={this.inputRef}
            onChange={this.onInputChange}
            className="signature-modal-type__input"
            type="text"
            placeholder={this.props.intl.formatMessage(messages.placeholderS)}
            defaultValue={this.props.initialTypeInValue}
            disabled={isLoadingFont}
            style={{ fontFamily: fonts[currentFontIndex] }}
            data-qa-ref="signing-modal--type-in-field" />
          {!this.isChineseLocale() ? (
            <Button
              kind={ButtonType.Subtle}
              className="signature-modal-type__change-font-button"
              data-qa-ref="signing-modal--change-font"
              onClick={this.onChangeFontPressed}
            >
              {this.props.intl.formatMessage(messages.linkText)}
            </Button>
          ) : null}
        </div>
      </div>
    );
  }
}

export default injectIntl(withSignatureModalContext(Type), { forwardRef: true });
